// extracted by mini-css-extract-plugin
export default {"tableRow":"areaList_tableRow__Bzstx","tableCell":"areaList_tableCell__rDL+N"};